import React from 'react'
import { InputText } from 'primereact/inputtext'

export default function LtsInputText(props) {
  const {
    onChange: onChangeProp,
    label,
    hidden,
    value = '',
    name,
    maxLength,
    autoFocus,
    keyfilter,
    style,
    disabled,
    className,
    ...rest
  } = props

  const handleChange = (event) => {
    onChangeProp?.(event.target.value)
  }

  return (
    <span className="p-float-label">
      <InputText
        {...rest}
        value={value}
        onChange={handleChange}
        name={name}
        maxLength={maxLength}
        autoFocus={autoFocus}
        keyfilter={keyfilter}
        style={style}
        disabled={disabled}
        className={className}
      />
      {label && !hidden && <label>{label}</label>}
    </span>
  )
}
